import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { setSelectedSystems } from "../../ducks/customersDuck";
import { triggerTrendShortPreLoad } from "../../../src/Dashboard/ducks/trendsDuck";
import { styled, alpha, Typography } from "@mui/material";
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';



const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.grey[200],
  [`& .${treeItemClasses.content}`]: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0),
    [`& .${treeItemClasses.label}`]: {
      fontSize: '0.8rem',
      fontWeight: 500,
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
  ...theme.applyStyles('light', {
    color: theme.palette.grey[800],
  }),
}));


const CustomerDeviceItem = ({ itemId, selectedSystems, deviceItem, customer }) => {

  console.log("itemId", itemId);
  console.log("deviceItem", deviceItem);
  const location = useLocation();
  const dispatch = useDispatch();

  let activeClassName = "";
  const filter = selectedSystems.filter(
    (item) => item.deviceId === deviceItem.deviceId
  );



  if (filter && filter.length > 0) {
    activeClassName = "selected";
  } else {
    activeClassName = "";
  }

  const onSelectDevice = (e, item) => {
    dispatch(triggerTrendShortPreLoad({ systemId: deviceItem.deviceId, SiteId: customer.customerId, DeviceId: deviceItem.deviceId }));
    const selectedDeviceItem = {
      ...item,
      customerId: customer.customerId,
      customerName: customer.customerName,
    };
    const id = item.deviceId;
    const isRemoving = selectedSystems.find((o) => o.deviceId === id);
    const selected =
      isRemoving && selectedSystems.filter((dev) => dev.deviceId !== id);
    const devices = isRemoving
      ? selected
      : [...selectedSystems, selectedDeviceItem];

    if (location.pathname === "/map") {
      dispatch(setSelectedSystems({ devices, path: "map" }));
    } else {
      dispatch(setSelectedSystems({ devices, path: "devices" }));
      localStorage.setItem("selectedSystems", JSON.stringify(devices));
    }
  };

  return (
    <CustomTreeItem
      // className={ClassNames("customer-device-item", activeClassName)}
      // role="presentation"
      key={itemId}
      id={itemId}
      onClick={(e) => {
        e.stopPropagation();
        onSelectDevice(e, deviceItem);
      }}
    >
      <Typography>{deviceItem.deviceName}</Typography>
    </CustomTreeItem>
  );
};


export default CustomerDeviceItem;
